import Header from "./components/Header/Header";
import Setup from "./containers/Setup/Setup";

function App() {
  return (
    <div className="container">
      <Header />
      <Setup />
    </div>
  );
}

export default App;
